module.exports = __webpack_public_path__ + "img/attendee.ceb24812.png";